
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^6(6841|8995)$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
